import React from "react";
import ReactPlaceholder from "react-placeholder/lib";
import { NodeOrMultipleNodes } from "./Aux";

/**
 * Placeholder: props => React element
 *
 * (c) Stefan Wittwer 2018 | Alle Rechte vorbehalten.
 *
 * Placeholder component which displays faux
 * content while data is being loaded
 *
 * @param {*} props
 */
const Placeholder = props => (
  <ReactPlaceholder showLoadingAnimation delay={100} {...props}>
    {props.children}
  </ReactPlaceholder>
);

Placeholder.propTypes = {
  children: NodeOrMultipleNodes.isRequired
};

export default Placeholder;



// WEBPACK FOOTER //
// ./src/components/utility/Placeholder.js